<template>
    <h3>Please wait, you are being redirected to the Home page</h3>
</template>

<script>
    import applicationUserManager from '../applicationusermanager'
    import { AuthURL, authHeader } from "../helper";
    import instance from "../helper/http";
    export default {
        async created() {
            try {
                await applicationUserManager.signinRedirectCallback()
                this.$router.push({ name: 'checkprofile' })
                //await applicationUserManager.signinRedirectCallback().then(function (user) {
                //    console.log("signin response success", user);
                    
                    
                //});
            } catch (e) {
                console.log(e)
            }
        },
        methods: {
            getprofile(){
                instance.get(AuthURL + "profile", {
                    headers: authHeader(),
                })
                    .then((response) => {
                        this.$store.commit("addrole", response.data.role);
                        this.$store.commit("cradLog", response.data.isCrad);
                        this.$store.commit("viewerLog", response.data.isViewer);
                        this.$router.replace({ name: "checkprofile" });

                    })
            }
        },
    }
</script>

<style>
</style>